/* =====================================================================
   SDN EFFECTS LAYER  ·  modular visual upgrade for the Bullet theme
   ---------------------------------------------------------------------
   - Loaded only when Theme settings → "SDN Visual Effects" is ON.
   - Everything is namespaced; the kill-switch is the `sdn-fx` body class
     (added in layout/theme.liquid). Remove that class or disable the
     setting to fully restore the original behaviour.
   - Effects are added step by step. STEP 1 = scaffold + card hover (CSS).
     Later steps (reveals, grain, marquee) plug into the hooks below.
   ===================================================================== */
(function () {
  'use strict';

  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Reflect the user's motion preference on <body> so CSS can react. */
  function applyMotionPref() {
    document.body.classList.toggle('sdn-reduced-motion', reduceMQ.matches);
  }

  /* STEP 3: inject the film-grain overlay layer (styled in sdn-effects.css,
     only visible while <body> has the `sdn-fx` class). */
  function ensureGrain() {
    if (document.getElementById('sdn-grain')) return;
    var g = document.createElement('div');
    g.id = 'sdn-grain';
    g.setAttribute('aria-hidden', 'true');
    document.body.appendChild(g);
  }

  /* PRODUCT GALLERY (desktop editorial layout):
     the layout itself is CSS (sdn-product.css). Here we only make the small
     thumbnails clickable: clicking a non-active slide promotes it to the main
     image via the theme's own media-gallery.setActiveMedia(). The active slide
     still opens the zoom (photoswipe) as before. */
  function initProductGallery(scope) {
    var galleries = (scope || document).querySelectorAll('.product-page media-gallery');

    galleries.forEach(function (gallery) {
      if (gallery.dataset.sdnGallery === '1') return;
      gallery.dataset.sdnGallery = '1';

      var viewer = gallery.querySelector('slider-component');
      if (!viewer) return;
      var mainWrap = viewer.querySelector('[id^="Slider-Gallery"]');
      if (!mainWrap) return;

      function slides() {
        return Array.prototype.slice.call(mainWrap.querySelectorAll('.slider__slide'));
      }

      /* which half of the active image is the pointer on? (-1 = left, +1 = right) */
      function side(e) {
        var active = mainWrap.querySelector('.slider__slide.is-active');
        var img = (active && active.querySelector('img')) || active || mainWrap;
        var r = img.getBoundingClientRect();
        return (e.clientX - r.left) > r.width / 2 ? 1 : -1;
      }

      /* go to next (+1) or previous (-1) image, wrapping around */
      function go(dir) {
        var arr = slides();
        if (arr.length < 2) return;
        var idx = 0;
        arr.forEach(function (s, i) { if (s.classList.contains('is-active')) idx = i; });
        var next = (idx + dir + arr.length) % arr.length;
        var id = arr[next].getAttribute('data-media-id');
        if (id && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(id, false);
      }

      /* gallery click/tap navigation is active from 778px up (tablet + desktop);
         below that the theme's native swipe gallery is used. */
      var desktop = function () { return window.matchMedia('(min-width: 778px)').matches; };

      /* directional arrow cursor over the product image (left half = back, right = next) */
      mainWrap.addEventListener('mousemove', function (e) {
        var active = e.target.closest('.slider__slide.is-active');
        if (!desktop() || !active || slides().length < 2) {
          mainWrap.classList.remove('sdn-nav-right', 'sdn-nav-left');
          return;
        }
        var right = side(e) > 0;
        mainWrap.classList.toggle('sdn-nav-right', right);
        mainWrap.classList.toggle('sdn-nav-left', !right);
      });
      mainWrap.addEventListener('mouseleave', function () {
        mainWrap.classList.remove('sdn-nav-right', 'sdn-nav-left');
      });

      /* click the product image -> previous / next (capture phase beats the zoom anchor).
         Desktop only — mobile keeps the theme's native swipe gallery. */
      mainWrap.addEventListener('click', function (e) {
        if (!desktop()) return;
        if (e.target.closest('.sdn-mark')) return;   /* Model-Marker: kein Bildwechsel */
        var active = e.target.closest('.slider__slide.is-active');
        if (!active) return;
        e.preventDefault();
        e.stopPropagation();
        go(side(e));
      }, true);
    });
  }

  /* PRODUCT BUY-BOX: turn SIZING / MATERIALS (and a fixed SHIPPING note) into a
     horizontal button row + one shared panel (accordion, only one open). */
  function initProductAccordion(scope) {
    var pcs = (scope || document).querySelectorAll('.product-page .bullet-product-content product-content');
    pcs.forEach(function (pc) {
      if (pc.dataset.sdnAcc === '1') return;
      pc.dataset.sdnAcc = '1';

      var desc = pc.querySelector('.description');
      var existing = desc ? Array.prototype.slice.call(desc.querySelectorAll('.pd-acc details')) : [];

      var versandHtml = '<p>Dispatch 1–3 working days after purchase; we ship out every Wednesday and Friday.<br>'
        + 'Delivery: Germany 2–5 working days · rest of the world 7–20 working days.</p>';
      /* Pre-order: product tag "preorder" -> marker from product-content.liquid */
      var versandLabel = 'SHIPPING';
      var preFlag = pc.querySelector('.sdn-preorder-flag');
      if (preFlag) {
        var tage = preFlag.getAttribute('data-days') || '30–65';
        versandLabel = 'SHIPPING (PRE ORDER)';
        versandHtml = '<p><strong>This piece is a pre-order.</strong> You order now and we produce it afterwards – that is how we can offer it at this price.</p>'
          + '<p>Dispatch starts <strong>' + tage + ' days</strong> after your purchase; we ship every Wednesday and Friday. You get an email with tracking as soon as it leaves.</p>'
          + '<p>Delivery after dispatch: Germany 2–5 working days · rest of the world 7–20 working days. Your statutory right of withdrawal applies as usual.</p>';
      } else if (pc.querySelector('.sdn-journey')) {
        versandHtml += '<p>Pre-order: ships after the production time stated in the description.</p>';
      }
      try {
        var eu = window.SDN_EU;
        if (eu && eu.hinweis) {
          var zusatz = '<p class="sdn-eu-note" style="margin-top:12px;opacity:.72">' + eu.hinweis;
          if (eu.link && eu.linkText) {
            zusatz += ' <a href="' + eu.link + '" style="text-decoration:underline;text-underline-offset:3px">' + eu.linkText + '</a>';
          }
          versandHtml += zusatz + '</p>';
        }
      } catch (e) {}

      var items = [{ label: versandLabel, html: versandHtml, wide: !!preFlag }];
      /* DOM order is SIZING then MATERIALS; reverse -> MATERIAL, SIZING (matches the design) */
      existing.reverse().forEach(function (d) {
        var sumSpan = d.querySelector('summary span') || d.querySelector('summary');
        var label = (sumSpan ? sumSpan.textContent : '').trim();
        var c = d.querySelector('.pd-acc-content');
        items.push({ label: label, html: c ? c.innerHTML : '' });
        var holder = d.closest('.pd-acc');
        if (holder) holder.style.display = 'none';   /* hide the original accordion */
      });

      var wrap = document.createElement('div'); wrap.className = 'sdn-acc';
      var tabs = document.createElement('div'); tabs.className = 'sdn-acc-tabs';
      var panel = document.createElement('div'); panel.className = 'sdn-acc-panel';

      items.forEach(function (it) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sdn-acc-tab' + (it.wide ? ' sdn-acc-tab--wide' : '');
        b.textContent = it.label || 'INFO';
        b.addEventListener('click', function () {
          var wasOpen = b.classList.contains('is-open');
          tabs.querySelectorAll('.sdn-acc-tab').forEach(function (x) { x.classList.remove('is-open'); });
          if (wasOpen) {
            panel.hidden = true;
            panel.innerHTML = '';
          } else {
            b.classList.add('is-open');
            panel.innerHTML = it.html;
            panel.hidden = false;
          }
        });
        tabs.appendChild(b);
      });

      wrap.appendChild(tabs);
      wrap.appendChild(panel);
      /* open SHIPPING by default */
      panel.innerHTML = items[0].html;
      panel.hidden = false;
      if (tabs.firstChild) tabs.firstChild.classList.add('is-open');

      (desc || pc).appendChild(wrap);

      /* avoid duplication: hide any pre-existing static shipping note
         (the same text now lives in the SHIPPING panel). Conservative:
         only small elements that literally contain the shipping phrase. */
      pc.querySelectorAll('p, small, div, span').forEach(function (el) {
        if (el.closest('.sdn-acc')) return;
        var t = (el.textContent || '').toLowerCase();
        if (t.indexOf('working days after purchase') !== -1 && el.children.length <= 2 && t.length < 220) {
          el.style.display = 'none';
        }
      });
    });
  }

  /* PRODUCT INFO SPLIT: move the title + price into a right-hand column
     (vertically centred), leaving the size/buy/accordion block on the left.
     Desktop only; on mobile everything stays in its original place. */
  function initProductInfoSplit(scope) {
    /* title + price move to the right column only in the 3-column desktop layout */
    var mql = window.matchMedia('(min-width: 1100px)');
    var pages = (scope || document).querySelectorAll('.product-page');

    pages.forEach(function (pg) {
      if (pg.dataset.sdnInfo === '1') return;
      pg.dataset.sdnInfo = '1';

      var grid = pg.querySelector('x-grid');
      var content = pg.querySelector('.bullet-product-content');
      if (!grid || !content) return;

      var title = content.querySelector('.title');
      var price = content.querySelector('section[id^="price-"]');
      if (!title && !price) return;

      var info = document.createElement('div');
      info.className = 'sdn-info';

      /* comment placeholders so we can restore exact positions on mobile */
      var tPh = document.createComment('sdn-title');
      var pPh = document.createComment('sdn-price');
      if (title) title.parentNode.insertBefore(tPh, title);
      if (price) price.parentNode.insertBefore(pPh, price);

      function toDesktop() {
        if (title && title.parentElement !== info) info.appendChild(title);
        if (price && price.parentElement !== info) info.appendChild(price);
        if (info.parentElement !== grid) grid.appendChild(info);
      }
      function toMobile() {
        if (title && title.parentElement === info) tPh.parentNode.insertBefore(title, tPh);
        if (price && price.parentElement === info) pPh.parentNode.insertBefore(price, pPh);
        if (info.parentElement) info.remove();
      }
      function apply() { if (mql.matches) toDesktop(); else toMobile(); }

      if (mql.addEventListener) mql.addEventListener('change', apply);
      else if (mql.addListener) mql.addListener(apply);
      apply();
    });
  }

  /* MODEL MARKS: white dot on model photos with "MODEL 1.80 M · WEARS SIZE L".
     Data: <script class="sdn-model-marks"> rendered by product-content.liquid
     from the product metafield custom.model_marker (metaobjects "model_marker"). */
  function initModelMarks(scope) {
    var pages = (scope || document).querySelectorAll('.product-page');
    pages.forEach(function (pg) {
      if (pg.dataset.sdnMarks === '1') return;
      var src = pg.querySelector('script.sdn-model-marks');
      if (!src) return;
      var marks;
      try { marks = JSON.parse(src.textContent); } catch (e) { return; }
      if (!marks || !marks.length) return;
      var slides = pg.querySelectorAll('media-gallery .slider__slide');
      if (!slides.length) return;
      pg.dataset.sdnMarks = '1';

      function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
      var all = [];

      marks.forEach(function (mk) {
        var slide = slides[(parseInt(mk.bild, 10) || 1) - 1];
        if (!slide) return;
        var img = slide.querySelector('img');
        if (!img) return;
        var x = Math.min(100, Math.max(0, parseFloat(mk.x) || 50));
        var y = Math.min(100, Math.max(0, parseFloat(mk.y) || 40));
        var mark = document.createElement('button');
        mark.type = 'button';
        mark.className = 'sdn-mark';
        mark.setAttribute('aria-label', mk.text || 'Model info');
        mark.innerHTML = '<span class="sdn-mark__dot"></span><span class="sdn-mark__label">' + esc(mk.text) + '</span>';
        mark.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          mark.classList.toggle('is-open');
        });
        slide.appendChild(mark);
        var label = mark.querySelector('.sdn-mark__label');

        function place() {
          var r = img.getBoundingClientRect(), s = slide.getBoundingClientRect();
          if (!r.width || !r.height) { mark.style.display = 'none'; return; }
          mark.style.display = '';
          var dx = r.left - s.left + r.width * x / 100, dy = r.top - s.top + r.height * y / 100;
          mark.style.left = dx + 'px';
          mark.style.top = dy + 'px';
          /* label side: right if it fits, else left, else centred below the dot (clamped to the photo) */
          var lw = label.offsetWidth || 0, pad = 6;
          var fitsRight = dx + 7 + 12 + lw + pad <= s.width;
          var fitsLeft = dx - 7 - 12 - lw - pad >= 0;
          mark.classList.remove('sdn-mark--left', 'sdn-mark--below');
          if (!fitsRight && fitsLeft) {
            mark.classList.add('sdn-mark--left');
          } else if (!fitsRight && !fitsLeft) {
            mark.classList.add('sdn-mark--below');
            var L = Math.min(Math.max(dx - lw / 2, pad), Math.max(pad, s.width - pad - lw));
            mark.style.setProperty('--lbl-left', (L - (dx - 7)) + 'px');
          }
        }
        place();
        if (!img.complete) img.addEventListener('load', place);
        if (window.ResizeObserver) { var ro = new ResizeObserver(place); ro.observe(img); ro.observe(slide); }
        window.addEventListener('resize', place);
        /* desktop gallery swaps the active slide via class changes */
        if (window.MutationObserver) {
          new MutationObserver(place).observe(slide, { attributes: true, attributeFilter: ['class', 'style'] });
        }
        var n = 0, t = setInterval(function () { place(); if (++n > 12) clearInterval(t); }, 250);

        /* open the label once when the photo comes into view, then fold back to the dot */
        if (window.IntersectionObserver) {
          var shown = false;
          new IntersectionObserver(function (entries, obs) {
            entries.forEach(function (en) {
              if (shown || !en.isIntersecting || en.intersectionRatio < 0.6) return;
              shown = true; obs.disconnect();
              setTimeout(function () { mark.classList.add('is-open'); }, 500);
              setTimeout(function () { if (!mark.matches(':hover')) mark.classList.remove('is-open'); }, 4500);
            });
          }, { threshold: [0.6] }).observe(slide);
        }
        all.push(mark);
      });

      /* tap elsewhere closes open labels (mobile) */
      document.addEventListener('click', function (e) {
        if (e.target.closest('.sdn-mark')) return;
        all.forEach(function (m) { m.classList.remove('is-open'); });
      });
    });
  }

  /* Central init — runs once on load. */
  function init() {
    applyMotionPref();
    ensureGrain();
    initProductGallery(document);
    initProductAccordion(document);
    initProductInfoSplit(document);   /* title+price -> right column on >=1100; centred below */
    initModelMarks(document);
    /* STEP 1 (card hover float) is pure CSS in sdn-effects.css. */
  }

  /* Re-run effects that target section markup when the Theme Editor
     re-renders a section (keeps live preview working). */
  function onSectionLoad(e) {
    var scope = e && e.target ? e.target : document;
    initProductGallery(scope);
    initProductAccordion(scope);
    initProductInfoSplit(scope);
    initModelMarks(scope);
  }

  if (reduceMQ.addEventListener) {
    reduceMQ.addEventListener('change', applyMotionPref);
  } else if (reduceMQ.addListener) {
    reduceMQ.addListener(applyMotionPref);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
})();
